
import { RootState } from '../rootState';
import { GetterTree, MutationTree, Module } from 'vuex';
import { ApiConfig } from '@/configs/apiConfig';

export interface Configuration extends ApiConfig {
    appName: string;
    baseUrl: string;
    appStyle: any;
    sceneStyle: any;
    menuStyle: any;
}

const getters: GetterTree<Configuration, RootState> = {
    configuration(state): Configuration {
        return state;
    },
};

const mutations: MutationTree<Configuration> = {
    setConfiguration(state, configuration: any) {
        const s = state as any;
        Object
            .keys(configuration)
            .filter((key) => key in s)
            .forEach((key) => s[key] = configuration[key]);
    }
};

export const currentState: Configuration = {
    appName: 'Creative',
    baseUrl: 'https://localhost:44332',
    appStyle: {},
    sceneStyle: {},
    menuStyle: {
        height: '100%',
        border: '1px solid black',
        'margin-bottom': '60px',
    },
};

export const ConfigurationModule: Module<Configuration, RootState> = {
    state: currentState,
    getters,
    mutations,
};
